import PortfolioAssets from './PortfolioAssets';

export default PortfolioAssets;
